import type { OrganisationWebhookStatus } from '@risksmart-app/domain/src/types/consts/organisation-webhook-status';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTRPC } from 'src/utils/trpc';

export interface UpdateWebhookInput {
  id: string;
  Title: string;
  Description: string | null;
  WebhookUrl: string;
  WebhookApiVersion: string;
  Status: OrganisationWebhookStatus;
  WebhookEventTypeIds: string[];
}

export const useUpdateWebhookTRPC = () => {
  const trpc = useTRPC();
  const queryClient = useQueryClient();
  const mutation = useMutation({
    ...trpc.frontend.webhook.update.mutationOptions({
      onSuccess: async () => {
        await queryClient.invalidateQueries({
          queryKey: trpc.frontend.webhook.list.queryKey(),
        });
      },
    }),
  });

  return {
    updateWebhook: async (input: UpdateWebhookInput) =>
      mutation.mutateAsync(input),
    loading: mutation.isPending,
    error: mutation.error,
  };
};
